import './tile.less';

// trim-below
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import block from 'bem-cn-lite';

const b = block('tile');

class ServiceItem extends Component {
	render() {
		const {title, summary, linkText, link, imagePath, imagePath2x} = this.props;

		return (
			<div className={b()}>
				<div className={b('container')}>
					<div className={b('picture')}>
						<img srcSet={`${imagePath} 405w, ${imagePath2x} 811w`}
							sizes="(max-width: 375px) 405px, (max-width: 960px) 811px, 405px"
							src={imagePath}
							className={b('img')}
						/>
					</div>
					<div className={b('content')}>
						<h3 className={b('title')}>{title}</h3>
						<p className={b('summary')}>{summary}</p>
						<a className={b('link')} href={link} title={title}>
							<span className={b('link-text')}>{linkText}</span>
						</a>
					</div>
				</div>
			</div>
		);
	}
}

ServiceItem.propTypes = {
	title: PropTypes.string,
	summary: PropTypes.string,
	link: PropTypes.string,
	linkText: PropTypes.string,
	imagePath: PropTypes.string,
	imagePath2x: PropTypes.string
};

export default ServiceItem;



// WEBPACK FOOTER //
// ./src/components/tiles/index.jsx